module.exports = __webpack_public_path__ + "img/index-6.a98b9b0a.png";